<template>
  <div
    class="error-area"
    :class="{ 'size-md': maxSize === 'md' }"
  >
    <div class="error-title">
      <BIcon class="warning-icon">
        warning
      </BIcon>
      {{ errorTitle }}
    </div>
    <div
      class="error-message"
    >
      {{ errorInfo }}
    </div>
    <div
      class="error-detail"
    >
      <slot name="error-detail" />
    </div>
  </div>
</template>

<script setup lang="ts">
type TMaxSize = 'md';
type TProps = {
  errorTitle: string;
  errorInfo: string;
  maxSize?: TMaxSize;
};
defineProps<TProps>();
</script>

<style lang="scss" scoped>
.error-area {
  background-color: #FFEEEE;
  border-radius: 4px;
  padding: 8px;

  .error-title {
    font-weight: bold;
    padding: 8px;
    .warning-icon {
      color: #FF6465;
      position: relative;
      padding-right: 4px;
    }
  }

  .error-message {
    padding: 4px 8px;
    color: #969696;
    white-space: pre-wrap;
  }

  .error-detail {
    color: #969696;
    padding-left: 8px;
    padding-right: 8px;
  }

  &.size-md {
    .error-message,
    .error-detail {
      max-height: 200px;
      overflow-y: auto;
    }
  }
}
</style>
